import API from '../../classes/Api/Api';
import URL from '../../classes/Url/URL';
import Role from '../../utils/Domain/Role';
import Response from '../../classes/Response/Response';

export async function auth() {
  return await new API(`${URL.URL_SERVER}/auth`).post({});
}

export async function role() {
  const data = await new API(URL.buildUrl('role'), {}).post({});
  return new Response(data, Role).single();
}
